import { getHost } from './request-utils'

// TEMPORARY (new-frontend pilot). Safe to delete once migration is complete.
// Hardcoded on purpose: avoids env-var deployment drift across old-FE servers,
// and avoids trusting a domain value supplied via cookie (open-redirect risk).

// Kill switch for redirecting new-user signups to the new frontend from the login
// page. Flip to false to instantly revert to the old in-app registration flow if
// something breaks on the new frontend's signup — no other code changes needed.
export const NEW_USER_SIGNUP_REDIRECT_ENABLED = true

const NEW_FRONTEND_HOST_MAP: Record<string, string> = {
  'api-test.sallysalary.dk': 'app-test.salaryadmin.com',
  'api-staging.sallysalary.dk': 'login-test.salaryadmin.com/register',
  'api.salary.dk': 'login.salary.dk/register',
  'localhost:3100': 'localhost:3000',
}

function normalizeHost(host: string): string {
  return host.replace(/^https?:\/\//, '').replace(/\/$/, '')
}

export function getNewFrontendRedirectUrl(): string | undefined {
  const host = normalizeHost(getHost())
  const newFrontendHost = NEW_FRONTEND_HOST_MAP[host]
  if (!newFrontendHost) {
    return undefined
  }
  const scheme = newFrontendHost.startsWith('localhost') ? 'http://' : 'https://'
  return scheme + newFrontendHost
}
